import * as React from "react";
const SvgCreateFilter20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 21,
        height: 21,
        fill: "black",
        viewBox: "0 0 21 21"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M20.26 5.536a4.803 4.803 0 0 1-6.617 4.449l-1.345 1.792v6.815l-5.556 2.084v-8.9L.26 3.135h11.037a4.803 4.803 0 0 1 8.963 2.402Zm-9.575-.55H3.964l4.63 6.173v6.844l1.852-.694v-6.15l1.647-2.195a4.788 4.788 0 0 1-1.408-3.978Zm3.771 1.55v2h2v-2h2v-2h-2v-2h-2v2h-2v2h2Z",
      clipRule: "evenodd"
    })
  );
export default SvgCreateFilter20Px;
